var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventTypeNotification01 = function SvgEventTypeNotification01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 62.93,
    y1: 203.15,
    x2: 188.67,
    y2: 59.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -24,
    y1: 126.84,
    x2: 101.74,
    y2: -16.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 19.47,
    y1: 164.99,
    x2: 145.21,
    y2: 21.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 46.25,
    y1: 188.5,
    x2: 171.99,
    y2: 45.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 47.4,
    y1: 189.51,
    x2: 173.14,
    y2: 46.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 47.83,
    y1: 189.89,
    x2: 173.57,
    y2: 46.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 20,
    y1: 165.46,
    x2: 145.74,
    y2: 22.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 12.19,
    y1: 158.6,
    x2: 137.93,
    y2: 15.36,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M70.25,190.61h12.52c1.62,0,2.94-1.31,2.94-2.94s-1.32-2.94-2.94-2.94h-12.52c-1.62,0-2.94,1.32-2.94,2.94s1.31,2.94,2.94,2.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.65,9.39h-6.26c-1.62,0-2.94,1.31-2.94,2.94s1.31,2.94,2.94,2.94h6.26c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.32,43.84h-37.77V9.2c0-5.07-4.13-9.2-9.2-9.2H32.68c-5.07,0-9.2,4.13-9.2,9.2v181.6c0,5.07,4.13,9.2,9.2,9.2h87.67c5.07,0,9.2-4.13,9.2-9.2v-53.42h37.77c5.07,0,9.2-4.13,9.2-9.2V53.03c0-5.07-4.13-9.2-9.2-9.2ZM29.35,9.2c0-1.83,1.49-3.33,3.33-3.33h87.67c1.83,0,3.33,1.49,3.33,3.33v9.59H29.35v-9.59ZM123.68,190.8c0,1.83-1.49,3.33-3.33,3.33H32.68c-1.83,0-3.33-1.49-3.33-3.33v-9.59h94.32v9.59ZM170.65,128.18c0,1.83-1.49,3.33-3.33,3.33h-75.15c-.63,0-1.25.21-1.76.59l-20.35,15.26v-70.84c0-1.62-1.32-2.94-2.94-2.94s-2.94,1.32-2.94,2.94v76.71c0,2.37,2.8,3.78,4.7,2.35l24.27-18.2h30.53v37.96H29.35V24.66h94.32v19.18h-50.29c-5.07,0-9.2,4.13-9.2,9.2v9.39c0,1.62,1.31,2.94,2.94,2.94s2.94-1.32,2.94-2.94v-9.39c0-1.83,1.49-3.33,3.33-3.33h93.93c1.83,0,3.33,1.49,3.33,3.33v75.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.4,109.59h-2.92c-.4-.16-3.53-1.77-3.53-12.72,0-21.62-11.65-24.85-18.59-24.85s-18.59,3.23-18.59,24.85c0,10.95-3.13,12.56-3.53,12.72h-2.92c-1.62,0-2.94,1.32-2.94,2.94s1.32,2.94,2.94,2.94h15.86c0,.07,0,.13,0,.2,0,5.07,4.13,9.2,9.2,9.2s9.2-4.13,9.2-9.2c0-.07,0-.13,0-.2h15.86c1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94ZM120.35,118.98c-1.83,0-3.33-1.49-3.33-3.33,0-.07,0-.13.01-.2h6.63c0,.07.01.13.01.2,0,1.83-1.49,3.33-3.33,3.33ZM105.52,109.59c1.23-2.75,2.12-6.79,2.12-12.72,0-18.98,9.57-18.98,12.72-18.98s12.72,0,12.72,18.98c0,5.93.89,9.97,2.12,12.72h-29.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.14,72.02c-1.62,0-2.94,1.32-2.94,2.94s1.32,2.94,2.94,2.94c3.56,0,6.46,2.9,6.46,6.46,0,1.62,1.32,2.94,2.94,2.94s2.94-1.32,2.94-2.94c0-6.8-5.53-12.33-12.33-12.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M139.14,59.49c-1.62,0-2.94,1.31-2.94,2.94s1.32,2.94,2.94,2.94c10.47,0,18.98,8.51,18.98,18.98,0,1.62,1.32,2.94,2.94,2.94s2.94-1.32,2.94-2.94c0-13.7-11.15-24.85-24.85-24.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.11,84.34c0-3.56,2.9-6.46,6.46-6.46,1.62,0,2.94-1.32,2.94-2.94s-1.32-2.94-2.94-2.94c-6.8,0-12.33,5.53-12.33,12.33,0,1.62,1.31,2.94,2.94,2.94s2.94-1.32,2.94-2.94Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.5,62.43c0-1.62-1.32-2.94-2.94-2.94-13.7,0-24.85,11.15-24.85,24.85,0,1.62,1.31,2.94,2.94,2.94s2.94-1.32,2.94-2.94c0-10.47,8.51-18.98,18.98-18.98,1.62,0,2.94-1.32,2.94-2.94Z"
  })));
};
export default SvgEventTypeNotification01;